import { render } from "./RechnungsempfaengerAdd.vue?vue&type=template&id=af49ff6e"
import script from "./RechnungsempfaengerAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./RechnungsempfaengerAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/RechnungsempfaengerAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af49ff6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af49ff6e', __exports__)) {
    api.reload('af49ff6e', __exports__)
  }
  
  module.hot.accept("./RechnungsempfaengerAdd.vue?vue&type=template&id=af49ff6e", () => {
    api.rerender('af49ff6e', render)
  })

}


export default __exports__